/**
 * Cytoscape node glyphs: each entity type's icon from ENTITY_ICON_COMPONENTS,
 * rendered to an SVG data URI for `background-image`.
 */

import { createLucideIcon, type LucideIcon } from 'lucide-react'
import { lucideSvgMarkup } from '@/utils/lucide-svg'
import { getEntityIconComponent } from './entity-icons'

/** Graph glyphs that deliberately differ from the type's React icon. */
const GRAPH_ICON_OVERRIDES: Record<string, LucideIcon> = {
  // A dial pad rather than the handset Phone also uses.
  PhoneNumber: createLucideIcon('dial-pad', [
    [
      'path',
      {
        d: 'M5 2h2v4H5zm6 0h2v4h-2zm6 0h2v4h-2zM5 9h2v4H5zm6 0h2v4h-2zm6 0h2v4h-2zM5 16h2v4H5zm6 0h2v4h-2zm6 0h2v4h-2z',
        key: 'dial-pad',
      },
    ],
  ]),
}

// The stylesheet is rebuilt on every theme switch; render each glyph once per color.
const dataUris = new Map<string, string>()

export function nodeIconDataUri(typeLabel: string, color: string): string {
  const key = `${typeLabel}:${color}`
  let uri = dataUris.get(key)
  if (uri === undefined) {
    const Icon = GRAPH_ICON_OVERRIDES[typeLabel] ?? getEntityIconComponent(typeLabel)
    uri = `data:image/svg+xml,${encodeURIComponent(lucideSvgMarkup(Icon, { color }))}`
    dataUris.set(key, uri)
  }
  return uri
}
